import { themeColor } from '@hud/web-components/theme/colors';
import { xsBold, xsRegular } from '@hud/web-components/theme/typography';
import styled from 'styled-components';

export const FunctionPopover = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Signature = styled.div`
  ${xsBold}
`;
export const FilePath = styled.div`
  ${xsBold}

  span:first-child {
    ${xsRegular}
    color: ${themeColor('textTertiary')};
  }
`;
